<ng-container *ngIf="mostraFiltroDisponibilita">



    <ng-container *ngIf="!mostraCaricamentoDisponibilitaUVM">
        <h4>Ricerca sessioni UVM disponibili</h4>
        <div>
            <strong>1 - Elenco qualifiche disponibili</strong>
            <div>
                <mat-form-field>
                    <mat-label>Cerca qualifica</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Infermiere" #input>
                </mat-form-field>

                <table mat-table [dataSource]="dataSource">



                    <ng-container matColumnDef="descrizione">
                        <th mat-header-cell *matHeaderCellDef> Qualifica </th>
                        <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
                    </ng-container>


                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> <button mat-button
                                (click)="addToSelected(element)"><mat-icon aria-hidden="false"
                                    aria-label="Aggiungi icona" fontIcon="add"></mat-icon> Aggiungi</button> </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">Nessun dato trovato per "{{input.value}}"</td>
                    </tr>


                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>

        <div>
            <strong>2 - Qualifiche selezionate</strong>
            <button mat-button (click)="svuotaListaQualifiche()"><mat-icon aria-hidden="false"
                    aria-label="Aggiungi icona" fontIcon="cancel"></mat-icon>Svuota lista</button>
            <table mat-table [dataSource]="dataSoruceSelected">



                <ng-container matColumnDef="descrizione">
                    <th mat-header-cell *matHeaderCellDef> Qualifica selezionata </th>
                    <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <button mat-button
                            (click)="rimuoviDaListaQualificheSelezionate(element)"><mat-icon aria-hidden="false"
                                aria-label="Aggiungi icona" fontIcon="delete"></mat-icon> Rimuovi</button> </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                        <div class="alert alert-warning " role="alert">
                            Nessun qualifica selezionata.
                        </div>
                    </td>
                </tr>


            </table>


        </div>

        <div class="mt-5">
            <strong>3 - Dati sessione UVM</strong>
            <div class="row">
                <div class="col">
                    <mat-form-field>
                        <mat-label>Durata sessione UVM (in ore)</mat-label>
                        <input matInput type="number" [(ngModel)]="uvmDuration" >
                    </mat-form-field>

                </div>

                <div class="col">
                    <mat-form-field>
                        <mat-label>Cerca disponibilità dalla data</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="dataInizioSessioneUVM">
                        <mat-hint>GG/MM/AAAA</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>



            <button mat-flat-button (click)="cercaDisponibilitaUVM()">Cerca disponibilità UVM</button>

        </div>
    </ng-container>

    <ng-container *ngIf="mostraCaricamentoDisponibilitaUVM">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>
</ng-container>





<ng-container *ngIf="mostraSceltaDisponibilita">

    <div>
        <h5>Elenco sessioni UVM disponibili</h5>

        <button mat-button (click)="back()"><mat-icon aria-hidden="false" aria-label="Aggiungi icona"
                fontIcon="arrow_back"></mat-icon>Torna alla ricerca sessioni disponibili</button>
        <table mat-table [dataSource]="dataSoruceDisponibilitaSessioneUVM">



            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef> Data</th>
                <td mat-cell *matCellDef="let element"> {{element.data | date : "dd/MM/yyyy"}} </td>
            </ng-container>


            <ng-container matColumnDef="oraInizio">
                <th mat-header-cell *matHeaderCellDef> Ora inizio </th>
                <td mat-cell *matCellDef="let element"> {{element.oraInizio}} </td>
            </ng-container>

            <ng-container matColumnDef="oraFine">
                <th mat-header-cell *matHeaderCellDef> Ora fine</th>
                <td mat-cell *matCellDef="let element"> {{element.oraFine}} </td>
            </ng-container>

            <!--<ng-container matColumnDef="struttura">
                <th mat-header-cell *matHeaderCellDef> Struttura </th>
                <td mat-cell *matCellDef="let element"> {{element.struttura.descrizione}} </td>
            </ng-container>-->


            <ng-container matColumnDef="operatoriBreve">
                <th mat-header-cell *matHeaderCellDef> Operatori </th>
                <td mat-cell *matCellDef="let element"> 

         {{getOperatoriNomi(element)}}
                </td>
            </ng-container>



            <ng-container matColumnDef="action2">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element"> <button mat-button
                        (click)="openDialogSceltaSessioneUVM(element)"><mat-icon aria-hidden="false"
                            aria-label="Aggiungi icona" fontIcon="check"></mat-icon> Seleziona sessione</button> </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumnsDisponibilitaSessioneUVM"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsDisponibilitaSessioneUVM;"></tr>


        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>

</ng-container>